<template>
<div class="footer">
  <p>Copyright &copy; {{new Date().getFullYear()}} Archipelago International</p>
</div>
</template>

<script>
export default {
  name: 'footertext',
  data() {
    return {

    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Footertext.vue